import { Stack } from "@mui/material";
import React, { FC } from "react";
import { FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSettings } from "@sinch/core/providers/AppSettings";
import { getWeekdayName } from "@sinch/utils/dateTime/format";
import { SelectInput } from "@sinch/components/form/SelectInput/SelectInput";
import { NumberInput, useMuiController } from "@sinch/components/index";

export const WeeklyOvertimeSettings: FC<{ disabled?: boolean; path?: string }> = ({ disabled, path = "settings" }) => {
  const { t } = useTranslation();
  const { safeLanguageCode } = useSettings();
  const { field: limitField } = useMuiController<FieldValues, string>({
    name: `${path}.limit`,
    disabled,
  });
  const { field: resetDayField } = useMuiController<FieldValues, string>({
    name: `${path}.resetDay`,
    disabled,
  });

  return (
    <Stack spacing={2}>
      <NumberInput {...limitField} fullWidth label={t("RateUnit.weeklyLimit")} />
      <SelectInput
        {...resetDayField}
        disablePortal
        label={t("RateUnit.resetDay")}
        options={Array.from({ length: 7 }, (_, i) => ({
          value: i + 1,
          label: getWeekdayName(i + 1, safeLanguageCode),
        }))}
      />
    </Stack>
  );
};
